import { render, staticRenderFns } from "./table5.vue?vue&type=template&id=d2e0b678&scoped=true&lang=pug&"
import script from "./table5.vue?vue&type=script&lang=js&"
export * from "./table5.vue?vue&type=script&lang=js&"
import style0 from "./table5.vue?vue&type=style&index=0&id=d2e0b678&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e0b678",
  null
  
)

export default component.exports